module.exports = __webpack_public_path__ + "img/pink2.36bd5d47.jpg";